const getTimeFromMillis = (milli) => {
  const time = new Date(milli);
  const hours = time.getUTCHours();
  if (hours) {
    return new Date(milli).toISOString().slice(11, -5);
  } else {
    return new Date(milli).toISOString().slice(14, -5);
  }
};

const getTemplateJsContext = () => {
  if (!document.getElementById('template-js-context')) {
    throw new Error('Missing template-js-context');
  }
  return JSON.parse(document.getElementById('template-js-context').textContent);
};

export { getTemplateJsContext, getTimeFromMillis };
